import { ReactElement } from 'react'
import useMediaQueries from '../useMediaQueries'
import BasicScroller from './BasicScroller'
import { ScrollerProps } from './common'
import ScrollerWithButtons from './ScrollerWithButtons'

const Scroller = (props: ScrollerProps): ReactElement => {
    const { whenDesktop, whenMobile } = useMediaQueries()

    if (props.forceButtons) {
        return <ScrollerWithButtons {...props} />
    }

    return (
        <>
            {whenMobile(() => (
                <BasicScroller {...props} />
            ))}
            {whenDesktop(() => (
                <ScrollerWithButtons {...props} />
            ))}
        </>
    )
}

export default Scroller
